module.exports = __webpack_public_path__ + "static/DY4-bc832dcf2413959f9b90a598f1b33ba8.jpg";